import { GridCellProps, GridColumnProps, GridFilterCellProps } from '@progress/kendo-react-grid'
import { multiSelectFilterCell } from 'components/Filter/FilterCell'
import { useAppSelector } from 'store'

const EligibilityCriteriaTypeFilterCell: React.FC<GridFilterCellProps> = (props) => {
  const eligibilityCriteriaTypes = useAppSelector(
    (state) => state.transactions.interestRateEligibilityCriteriaType
  )
  return multiSelectFilterCell({
    items: eligibilityCriteriaTypes.map((x) => ({ id: x.id, value: x.id, label: x.name })),
  })(props)
}

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

const interestRatesEligibilityColumns: GridColumn[] = [
  {
    title: 'Criteria Type',
    field: 'eligibilityCriteriaType.name',
    filterCell: EligibilityCriteriaTypeFilterCell,
    cell: (props: GridCellProps): JSX.Element => {
      if (!props?.dataItem?.eligibilityCriteriaType.name) {
        return <td />
      }

      return <td>{props.dataItem.eligibilityCriteriaType.name}</td>
    },
    width: 250,
    filterable: true,
    show: true,
  },
  {
    title: 'Value',
    field: 'value',
    cell: (props: GridCellProps): JSX.Element => {
      if (!props?.dataItem?.value) {
        return <td />
      }

      return <td>{props.dataItem.value}</td>
    },
    filterable: false,
    show: true,
  },
]

export default interestRatesEligibilityColumns
